import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RewardCodeService {

  constructor(private http: HttpClient) { }

  getRewardCode(params?): Observable<any> {
    return this.http.get(`${environment.urlDev}${environment.public}mydico/reward-codes`, {params});
  }
}
